import { useState } from "react";
import { useRecordContext, useTranslate } from "ra-core";
import { Edit } from "@/components/admin/edit";
import { SimpleForm } from "@/components/admin/simple-form";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { MarkPaymentPaidSheet } from "../shared/MarkPaymentPaidSheet";
import { PaymentInputs } from "./PaymentInputs";
import type { Payment } from "../../types";

export const PaymentEdit = () => (
  <Edit mutationMode="pessimistic" redirect="show">
    <div className="max-w-3xl space-y-4">
      <MarkPaidAction />
      <SimpleForm>
        <PaymentInputs />
      </SimpleForm>
    </div>
  </Edit>
);

const MarkPaidAction = () => {
  const translate = useTranslate();
  const payment = useRecordContext<Payment>();
  const [open, setOpen] = useState(false);
  if (!payment || payment.status === "paid") return null;
  const isExpense = payment.direction === "expense";
  return (
    <div>
      <Button onClick={() => setOpen(true)}>
        <CheckCircle2 className="h-4 w-4 mr-2" />
        {isExpense
          ? translate("finance.markPaid.actionExpense", { _: "Провести выплату" })
          : translate("finance.markPaid.action", { _: "Принять оплату" })}
      </Button>
      <MarkPaymentPaidSheet open={open} onOpenChange={setOpen} payment={payment} />
    </div>
  );
};
